import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c0a9703c&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/ug-quartz-client-prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0a9703c')) {
      api.createRecord('c0a9703c', component.options)
    } else {
      api.reload('c0a9703c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c0a9703c&", function () {
      api.rerender('c0a9703c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/u8-sms-cd/index.vue"
export default component.exports